<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <div class="cell shrink">
        <template v-if="$route.name === 'Bekreftelsebrev' || $route.name === 'BekreftelsebrevGodkjenning'">
          <a href="javascript:;" class="button primary" v-if="submitStatus === 'submittable'" @click="onReloadClick()">Reload</a>
          <a href="javascript:;" class="button primary loading" v-else-if="submitStatus === 'loading'">Reload <span class="loader-spinner"></span></a>
          <a href="javascript:;" class="button primary" disabled v-else>Reload</a>
        </template>
        <template v-if="$route.name === 'BekreftelsebrevHistorikk'">
          <a href="javascript:;" class="button primary" v-if="submitStatus === 'submittable'" @click="onSearchClick()">Søk</a>
          <a href="javascript:;" class="button primary loading" v-else-if="submitStatus === 'processing'">Søker... <span class="loader-spinner"></span></a>
          <a href="javascript:;" class="button primary" disabled v-else>Søk</a>
        </template>
         <template v-if="$route.name === 'BekreftelsebrevNy'">
          <a href="javascript:;" class="button primary" v-if="submitStatus === 'submittable'" @click="onSaveClick()">Opprett</a>
          <a href="javascript:;" class="button primary loading" v-else-if="submitStatus === 'processing'">Oppretter bekreftelsebrev... <span class="loader-spinner"></span></a>
          <a href="javascript:;" class="button primary" disabled v-else>Opprett</a>
        </template>

        <a v-if="submitStatus === 'processing'" class="button primary transparent" style="color: #bbb; cursor: not-allowed;">Gå tilbake</a>
        <router-link v-else :to="{ name: 'ReportsList' }" class="button primary transparent" >Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <ul>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'Bekreftelsebrev'}">Ubehandlede</router-link>
            </li>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'BekreftelsebrevGodkjenning'}">Til godkjenning</router-link>
            </li>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'BekreftelsebrevHistorikk'}">Historikk</router-link>
            </li>
            <li>
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'BekreftelsebrevNy'}">Lag ny</router-link>
            </li>
          </ul>
        </div>
      </div>

      <router-view v-on:onSubmitStatusChange="onSubmitStatusChange"></router-view>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'Bekreftelsebrev',
  data () {
    return {
      submitStatus: null
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Rapporter - Bekreftelsebrev'
    }
  },
  methods: {
    onSubmitStatusChange: function (status) {
      this.submitStatus = status
    },
    onReloadClick: function () {
      bus.$emit('reload-bekreftelsebrev')
    },
    onSaveClick: function () {
      bus.$emit('save-bekreftelsebrev')
    },
    onSearchClick: function () {
      bus.$emit('search-bekreftelsebrev')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Bekreftelsebrev.vue